import React from 'react';
import './styles.css'; 
import { CSSProperties } from 'styled-components';

interface BallotProps {
  color?: string;
  children: React.ReactNode;
  style?: CSSProperties;
  className?: string;
}

const Ballot: React.FC<BallotProps> = ({ color = 'blue', children, style, className }) => {
  return (
    <div
      className={`result-ballot mx-2 d-flex justify-content-center align-items-center ${className || ''}`}
      style={{
        ...style,
        flex: '0 1 90px', 
        borderRadius: '50%', 
        position: 'relative',
      }}
    >
      <div className="ballot-result">
        <h1 className="fw-bold text-white">{children}</h1>
      </div>
      <div
        className="color-filter"
        style={{
          backgroundColor: color,
          borderRadius: '50%',
          width: '100%', 
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      ></div>
    </div>
  );
};

export default Ballot;
